module.exports = __webpack_public_path__ + "static/media/contact-info-icon1.04e4f259.svg";